import {
  Section,
  ReadOnlyField,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type FabricDetailsSectionProps = {
  item: VendorCatalogItem | undefined;
};

function FabricDetailsSection({ item }: FabricDetailsSectionProps) {
  return (
    <Section
      icon="scale"
      title="Fabric Details"
      color="pink"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      withoutBorder
      iconColor="black"
      data-testid="fabric-details-readonly-section"
    >
      <Stack direction="col" className="gap-3">
        <Stack direction="row" className="gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Weight"
            value={item?.fabric_weight}
            suffix="gsm"
            id="fabric-weight"
          />
        </Stack>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Fabric Code & Name"
            value={item?.fabric_code_and_name}
            id="fabric-code-and-name"
          />
          <ReadOnlyField
            className="flex-1"
            label="Fabric Type"
            value={item?.fabric}
            id="fabric-type"
          />
        </div>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Pattern/Print"
            value={item?.pattern_print}
            id="pattern-print"
          />
          <ReadOnlyField
            className="flex-1"
            label="Wash"
            value={item?.wash}
            id="wash"
          />
        </div>
      </Stack>
    </Section>
  );
}

export default FabricDetailsSection;
